import React, {useCallback, useEffect, useState} from "react";
import {QueryClient, QueryClientProvider} from "react-query";
import {ACard, ADataGrid, ADataGridColumn, ADataGridFilter, PagedSearchParams} from "@atiautomacao/ati-ui-library";
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "../../../Config/Hooks";
import {extractFiltersFromColumns} from "../../../Utils/DataUitils";
import {AlarmSeverityReactQuery, DeleteAlarmSeverityReactQuery} from "../AlarmSeverity/AlarmSeverityReactQuery";
import {Box, TextField, Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {Delete, Edit} from "@mui/icons-material";
import {SystemRoutes} from "../../../Utils/RouteUtils";
import {DeleteStatusColorReactQuery, StatusColorReactQuery} from "./StatusColorReactQuery";
import ConfirmDialog from "../../../Shared/Components/ConfirmDialog";
import {HeaderMenu} from "../HeaderMenu";




export const initColumns = [
    {
        name: 'id',
        label: 'ID',
        align: 'center',
        visibility: false,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'name',
        label: 'Nome',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'color',
        label: 'Cor',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'statusTypeEnum',
        label: 'Tipo dos Status',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'priority',
        label: 'Prioridade',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
] as ADataGridColumn[]


export type ActionConfig = {
    actionName: string;
    disabled: boolean;
};

export interface RowStatusColor {
    id?: number;
    name: string;
    color: string;
    statusTypeEnum: string;
    priority: number;
    actionsConfig?: Array<ActionConfig>
}

export const StatusColorSettingsPage = () => {
    const navigate = useNavigate();
    const account = useAppSelector(state => state.authentication.account);

    const [selectedToDelete, setSelectedToDelete] = useState<any>(null);
    const [selectedToDeleteName, setSelectedToDeleteName] = useState<string | null>(null);


    const [pagedSearchParams, setPagedSearchParams] = useState(new PagedSearchParams(extractFiltersFromColumns(initColumns), 0, 50));
    const handleOnFiltersChange = useCallback((dataGridFilters: Array<ADataGridFilter>, page: number, pageSize: number) => {
        const newDataGrid:Array<ADataGridFilter> = dataGridFilters.map(filter => {
            filter.value = filter.value.replace(/#/g, "");
            return filter;

        })
        let newPageParams: PagedSearchParams = new PagedSearchParams(newDataGrid, page, pageSize);
        setPagedSearchParams(
            newPageParams
        );
    }, []);

    const { data, isSuccess } = StatusColorReactQuery(pagedSearchParams);
    const mutation = DeleteStatusColorReactQuery(pagedSearchParams);
    const [totalOfRecords, setTotalOfRecords] = useState(0);
    const [rows, setRows] = useState<Array<RowStatusColor>>([]);
    const [openDialog, setOpenDialog] = useState(false);


    useEffect(() => {
        if(isSuccess){
            setTotalOfRecords(data?.totalOfRecords);
            if(data?.data){
                let rowsStatusColor = data.data.map((statusColor: any) => {
                    return {
                        id: statusColor?.id,
                        name: statusColor?.name,
                        color: <Box style={{display: "flex", alignItems: "center"}}>

                            <TextField
                                error={statusColor?.color === ""}
                                fullWidth
                                id="type-color"
                                variant="standard"
                                type="color"
                                disabled={true}
                                value={`#${statusColor?.color?.trim()}`}
                                style={{width: 24, marginRight: 5}}
                                sx={{
                                    '& ::before': {
                                        content: 'none',
                                    },
                                }}
                            />
                            <p style={{width: "80%"}}>#{statusColor?.color?.trim()}</p>
                        </Box>
                        ,
                        statusTypeEnum: statusColor?.statusTypeEnum,
                        priority: statusColor?.priority,
                        actionsConfig: [
                            {actionName: "edit"},
                            {actionName: "delete"},
                        ]
                    }
                });
                setRows(rowsStatusColor);
            }
        }
    }, [data?.data]);

    const handleEditAlarmSeverity = useCallback((data: any) => {
        navigate(SystemRoutes.SETTINGS_STATUS_COLOR_FORM, { state: { id: data.id } });
    },[navigate]);

    const handleDeleteAlarmSeverity = useCallback((data: any) => {
        setSelectedToDelete(data.id);
        setSelectedToDeleteName(data.name);
        setOpenDialog(true);
    },[]);

    useEffect(() => {
        if(mutation.isSuccess) {
            setPagedSearchParams(new PagedSearchParams(extractFiltersFromColumns(initColumns), 0, 50))
        }

    }, [mutation.isSuccess]);

    const handleDialogToggle = () => {
        setOpenDialog(!openDialog);
    }

    const handleDialogConfirm = async () => {
        mutation.mutate({ id: selectedToDelete, pagedSearchParams });
        setSelectedToDelete(null);
        handleDialogToggle();
    }

    const handleDialogClose = () => {
        setSelectedToDelete(null);
        setSelectedToDeleteName(null);
        handleDialogToggle();
    }


    return (
        <>
            <HeaderMenu systemRoutes={SystemRoutes.SETTINGS_STATUS_COLOR_FORM}/>

            <Box>
                <ACard>
                    <ADataGrid
                        hideFilters={false}
                        showFilterOptions={false}
                        hideSelection={false}
                        columns={initColumns}
                        rows={rows}
                        page={pagedSearchParams.page}
                        rowsPerPage={pagedSearchParams.size}
                        loading={false}
                        totalOfRecords={totalOfRecords}
                        onFiltersChange={handleOnFiltersChange}
                        actions={
                            <>
                                <IconButton name="edit" size={"small"} aria-label="Edit"
                                            onClick={(value) => handleEditAlarmSeverity(value)}>
                                    <Tooltip title="Editar">
                                        <Edit/>
                                    </Tooltip>
                                </IconButton>
                                <IconButton name="delete" size={"small"} aria-label="Delete"
                                            onClick={(value) => handleDeleteAlarmSeverity(value)}>
                                    <Tooltip title="Excluir">
                                        <Delete/>
                                    </Tooltip>
                                </IconButton>
                            </>
                        }
                    />
                </ACard>
            </Box>
            <ConfirmDialog
                title={'Deletar'}
                description={`Deseja deletar a severidade ${selectedToDeleteName}?`}
                open={openDialog}
                handleConfirm={handleDialogConfirm}
                handleClose={handleDialogClose}
            />
        </>


    )
}



export default function StatusColorHomePage() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <StatusColorSettingsPage/>
        </QueryClientProvider>
    )
}